import AccessControl from './access_control';
import Utils from './utils';

// XPEN-3795: the latest return of a report to its employee, shown while the report is Pending again.
export function latestReturn(expensesAccount) {
  const returns = Array.isArray(expensesAccount?.returns) ? expensesAccount.returns : [];
  if (expensesAccount?.status !== 'Pending' || returns.length === 0) return null;
  return returns[returns.length - 1];
}

export function returnedByLabel(entry, data) {
  const by = entry?.by || {};
  const name = [by.first_name, by.last_name].filter(Boolean).join(' ') || by.username || '';
  const at = entry?.at ? new Date(entry.at) : null;
  const date = at && !Number.isNaN(at.getTime()) ? at.toLocaleDateString(data.t.lang === 'fr' ? 'fr-CA' : 'en-CA') : '';
  return data.t.read('return_to_employee.returned_by').replace('{name}', name).replace('{date}', date);
}

// XPEN-3795: as on the server, an exported report invoice is never deleted, and a decided one
// needs the return action, since deleting it sends the report back to its employee too.
export function reportInvoicesBlockDelete(selection, data) {
  const reportInvoices = (selection || []).filter((invoice) => invoice?.type === 'XPENSE');
  if (reportInvoices.some((invoice) => ['Finalizing', 'Finalized'].includes(invoice.status))) return true;
  return reportInvoices.some((invoice) => !Utils.DELETABLE_STATUSES.includes(invoice.status))
    && !AccessControl.userCanReturnExpenseReports(data);
}
